export default class Search {
  constructor(el) {
    this.el = el;
    this.searchBtn = null;
    this.searchContent = null;
    this.searchForm = null;
    this.init();
    this.initEvents();
  }

  init() {
    this.searchBtn = this.el.querySelector(".refine-search__toggle");
    this.searchContent = this.el.querySelector(".refine-search__content");
    this.searchForm = this.el.querySelector(".refine-search__filters");
  }

  initEvents() {
    this.searchBtn.addEventListener("click", (e) => {
      e.preventDefault();
      this.toggleSearch();
    });
  }

  toggleSearch() {
    this.searchBtn.classList.toggle("active");
    this.searchContent.classList.toggle("active");
    this.searchForm.classList.toggle("hidden");
    this.searchForm.classList.toggle("visible");
  }
}
